export function hasAckDecReactions(message) {
    if (message.reactions === undefined) {
        return false;
    }
    return message.reactions.ack.length > 0 || message.reactions.dec.length > 0;
}
export default [
    function () {
        return {
            restrict: 'EA',
            scope: {},
            bindToController: {
                message: '=eeeMessage',
            },
            controllerAs: 'ctrl',
            controller: ['WebClientService', '$filter', function (webClientService, $filter) {
                    const idsToNames = $filter('idsToNames');
                    this.$onInit = function () {
                        const message = this.message;
                        this.reactions = {
                            up: {
                                count: message.reactions?.ack?.length ?? 0,
                                names: '',
                                icon: (message.reactions?.ack ?? []).includes(webClientService.me.id) ? 'thumb_up' : 'thumb_up_off_alt',
                            },
                            down: {
                                count: message.reactions?.dec?.length ?? 0,
                                names: message.reactions?.dec?.sort()?.join(', ') ?? '',
                                icon: (message.reactions?.dec ?? []).includes(webClientService.me.id) ? 'thumb_down' : 'thumb_down_off_alt',
                            },
                        };
                        const upvoters = message.reactions?.ack ?? [];
                        const downvoters = message.reactions?.dec ?? [];
                        if (upvoters.length > 0) {
                            this.reactions.up.names = idsToNames(upvoters, true);
                        }
                        if (downvoters.length > 0) {
                            this.reactions.down.names = idsToNames(downvoters, true);
                        }
                        this.hasReaction = this.reactions.up.count > 0 || this.reactions.down.count > 0;
                    };
                }],
            template: `
                <span class="reaction-ack" ng-if="ctrl.reactions.up.count > 0" title="{{ctrl.reactions.up.names}}">
                    <i class="material-icons md-14">{{ctrl.reactions.up.icon}}</i>
                    {{ctrl.reactions.up.count}}
                </span>
                <span class="reaction-dec" ng-if="ctrl.reactions.down.count > 0" title="{{ctrl.reactions.down.names}}">
                    <i class="material-icons md-14">{{ctrl.reactions.down.icon}}</i>
                    {{ctrl.reactions.down.count}}
                </span>
                <span class="reaction-margin" ng-if="ctrl.hasReaction"></span>
            `,
        };
    },
];
